/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {RegistDialogComponent} from "../../../platform/auth/regist-dialog/regist-dialog.component";

import {AigiaAuthService} from "../aigia-auth.service";
import {Router} from "@angular/router";
import {AuthLevel, IErrorObject} from "../../../../../types/platform/universe";
import {TranslateService} from "@ngx-translate/core";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-regist-dialog",
	styleUrls: ["../aigia-auth.component.css"],
	templateUrl: "./aigia-regist-dialog.component.html",
})
export class AigiaRegistDialogComponent extends RegistDialogComponent implements OnInit {

	/**
	 * @constructor
	 * @param data
	 * @param matDialogRef
	 * @param snackbar
	 * @param auth
	 * @param router
	 * @param translate
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<AigiaRegistDialogComponent>,
		public snackbar: MatSnackBar,
		private matDialog: MatDialog,
		public auth: AigiaAuthService,
		protected router: Router,
		public translate: TranslateService
	) {
		super(data, matDialogRef, snackbar, auth, router);
	}

	/**
	 * todo
	 */
	public toNickname(): void {
		const names: string[] | null = this.content.username.split("@");
		if (names) {
			if (names.length > 0) {
				this.content.nickname = names[0];
			}
		}
	}

	/**
	 * todo
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: this.translate.instant(error.message), tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * todo
	 */
	public onAccept(): void {
		this.Progress(true);
		const category: string = "";
		const type: string = "";
		const auth: number = AuthLevel.user;
		const metadata: any = {nickname: this.content.nickname, id: this.content.params};
		this.auth.regist(auth, this.content.username, this.content.password, category, type, metadata, (error: IErrorObject, result: any) => {
			if (!error) {
				this.matDialogRef.close(this.data);
			} else {
				this.errorDialog(error);
			}
			this.Progress(false);
		});
	}
}
